import React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons';

import { Icon, Input } from '../../../../main/scripts/lumen';
import { SortDropdown } from './SortDropdown';

export const ProjectsToolbar = ({
  searchValue,
  onSearchChange,
  sortValue,
  onSortChange,
  viewMode = 'grid',
  onViewModeChange
}) => (
  <Bar>
    <Left>
      <SearchWrap>
        <Input
          icon="search"
          placeholder="Search Project"
          value={searchValue}
          onChange={event => onSearchChange?.(event.target.value)}
          aria-label="Search projects"
        />
      </SearchWrap>
      <SortDropdown value={sortValue} onChange={onSortChange} />
    </Left>
    <Right>
      <ViewButton
        type="button"
        aria-label="Grid view"
        aria-pressed={viewMode === 'grid'}
        $active={viewMode === 'grid'}
        onClick={() => onViewModeChange?.('grid')}
      >
        <Icon name="grid-2" size={16} />
      </ViewButton>
      <ViewButton
        type="button"
        aria-label="List view"
        aria-pressed={viewMode === 'list'}
        $active={viewMode === 'list'}
        onClick={() => onViewModeChange?.('list')}
      >
        <FontAwesomeIcon icon={faList} style={ICON_STYLE} />
      </ViewButton>
    </Right>
  </Bar>
);

const ICON_STYLE = { width: 16, height: 16 };

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: ${({ theme }) => theme.color.bg.default};
  border: 1px solid ${({ theme }) => theme.color.slate[200]};
  border-radius: 12px;
  gap: 16px;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`;

const SearchWrap = styled.div`
  width: 264px;

  input {
    height: 36px;
    border-color: ${({ theme }) => theme.color.slate[500]};
    font-size: 16px;
  }
`;

const ViewButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: ${({ $active, theme }) =>
    $active ? theme.color.slate[100] : theme.color.bg.default};
  border: 1px solid ${({ theme }) => theme.color.slate[200]};
  border-radius: 8px;
  cursor: pointer;
  color: ${({ $active, theme }) =>
    $active ? theme.color.fg.default : theme.color.fg.muted};

  &:hover {
    background: ${({ theme }) => theme.color.slate[100]};
    color: ${({ theme }) => theme.color.fg.default};
  }
`;
